import { render, staticRenderFns } from "./purchaseManagement.vue?vue&type=template&id=f9d69a48&scoped=true&"
import script from "./purchaseManagement.vue?vue&type=script&lang=js&"
export * from "./purchaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./purchaseManagement.vue?vue&type=style&index=0&id=f9d69a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d69a48",
  null
  
)

export default component.exports